import React from "react";
import { GlobeIcon } from "lucide-react";
type Props = {
  tone?: "dark" | "light";
};
export function CurrencyNote({
  tone = "light"
}: Props) {
  return <p className={`mt-4 flex items-start justify-center gap-2 text-center text-[13px] leading-snug ${tone === "dark" ? "text-white/75" : "text-muted"}`} data-id="element-33" data-mp="1nwmi1s6dnvqb">
      <GlobeIcon className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" data-id="element-34" data-mp="1e3oxzhlqlypl" />
      <span data-id="element-35" data-mp="1057clqjb0yau">The price is converted automatically to your local currency at checkout.</span>
    </p>;
}